import {
  addToGarageRequested,
  discardVehicleFieldsRequested,
  forceVehicleSelectionLater,
  garageCleanupRequested,
  ignoreInexactFields,
  removalFromGarageRequested,
  replaceVehicleValue,
  setGarageRequested,
  vehicleColorUpdated,
  vehicleDiscardingRequested,
  vehicleSelected,
  vehicleSpecificationNeeded,
} from 'Core/actions/fitmentSearch/index';
import { resetRequest } from 'Core/actions/request';
import { viewChangeRequested } from 'Core/actions/show';
import { garageDataSelector, selectedVehicleSelector } from 'Core/selectors/fitmentSearch/index';
import type { ReduxStateType } from 'Core/store';
import { VehicleCollection } from 'Models/index';
import uiConfig from 'Models/uiConfig/uiConfig';
import {
  keys,
  loadSelectedVehicle,
  removeVehicleData,
  setForceVehicleSelectionLater,
  setVehicleData,
} from 'Utils/userStorage';

import { epicFromHandlers } from './common';

export default epicFromHandlers(
  {
    [forceVehicleSelectionLater.type]: setForceVehicleSelectionLater,
    [garageCleanupRequested.type]: () => {
      removeVehicleData(keys.vehicle);
      removeVehicleData(keys.garageData);

      window.Convermax.onVehicleRemoved?.(VehicleCollection.empty);
    },
    [replaceVehicleValue.type]: ({ action }) => !action.meta.isolatedKey && removeVehicleData(keys.vehicle),
    [vehicleDiscardingRequested.type]: () => {
      removeVehicleData(keys.vehicle);
    },
    [resetRequest.type]: ({ action: { payload: { discardVehicle } = {} } }) =>
      discardVehicle && removeVehicleData(keys.vehicle),
    [discardVehicleFieldsRequested.type]: ({ state }) =>
      setVehicleData(keys.vehicle, selectedVehicleSelector(state).serializable),
    [ignoreInexactFields.type]: putVehicleAndGarageToStorage,
    [setGarageRequested.type]: ({
      action: {
        payload: { vehicles, selectVehicle },
      },
    }) => {
      setVehicleData(keys.garageData, vehicles.serializable);
      if (selectVehicle) {
        setVehicleData(keys.vehicle, vehicles.last.serializable);
      }
    },
    [removalFromGarageRequested.type]: ({
      state,
      action: {
        meta: { wasSelected },
      },
    }) => {
      const garageData = garageDataSelector(state);
      if (garageData.size) {
        setVehicleData(keys.garageData, garageData.serializable);
      } else {
        removeVehicleData(keys.garageData);
      }
      if (wasSelected) {
        removeVehicleData(keys.vehicle);
      }

      window.Convermax.onVehicleRemoved?.(garageData);
    },
    [addToGarageRequested.type]: ({ state }) => {
      const garageData = garageDataSelector(state);
      setVehicleData(keys.garageData, garageData.serializable);
    },
    [vehicleSelected.type]: (arg) => {
      putVehicleAndGarageToStorage(arg);
    },
    [vehicleSpecificationNeeded.type]: putVehicleAndGarageToStorage,
    [vehicleColorUpdated.type]: ({
      state,
      action: {
        payload: { vehicle },
      },
    }) => {
      if (vehicle.equals(loadSelectedVehicle())) {
        setVehicleData(keys.vehicle, vehicle.serializable);
        const garageData = garageDataSelector(state);
        setVehicleData(keys.garageData, garageData.serializable);
      }
    },
    [viewChangeRequested.type]({ action: { payload } }) {
      if (payload === uiConfig.defaultView) {
        removeVehicleData(keys.view);
      } else {
        setVehicleData(keys.view, payload);
      }
    },
  },
  'localStorage',
);

function putVehicleAndGarageToStorage({ state }: { state: ReduxStateType }) {
  setVehicleData(keys.vehicle, selectedVehicleSelector(state).serializable);
  const garageData = garageDataSelector(state);
  if (garageData.size) {
    setVehicleData(keys.garageData, garageData.serializable);
  }
}
